import styled from "styled-components";

export const TournamentStateInfoWrapper = styled.div`
  margin: 0 16px;
  height: 163px;
  border-radius: 9px;
  box-shadow: 0px 0px 12px 0px #00000040;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const CircularProgress = styled.svg`
  width: 57px;
  height: 57px;
  border-radius: 50%;
  transform: rotate(0.25turn);

  circle {
    fill: none;
    stroke-width: 8;
  }

  .background {
    stroke: #fff;
  }

  .progress {
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;

export const TournamentStateInfoTimerWrapper = styled.div`
  justify-content: start;
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const TournamentStateTimerBox = styled.div`
  position: relative;
  width: 73px;
  height: 73px;
  border-radius: 14px;
  background: rgba(100, 54, 231, 1);
  display: flex;
  justify-content: center;
  align-items: center;

  > .time {
    color: white;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const TournamentStateInfoLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;

  > .entry {
    font-weight: 600;
    font-size: 14px;
  }
`;

export const TournamentStateInfoLevel = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 23.87px;
  letter-spacing: -0.02em;
  text-align: left;
`;

export const TournamentStateInfoBlindWrapper = styled.div`
  display: flex;
  background: #ecf0f3;
  height: 45px;
  border-radius: 8px;
  align-items: center;
`;

export const TournamentStateInfoBlindItem = styled.div`
  flex: 1;
  display: flex;
  gap: 2px;
  flex-direction: column;
  border-right: 0.5px solid #12121280;

  &:last-child {
    border-right: none;
  }

  > .name {
    font-weight: 400;
    font-size: 9px;
    text-align: center;
    color: #121212;
  }

  > .blind {
    font-weight: 700;
    font-size: 10px;
    text-align: center;
  }
`;
